import React, { Suspense, useRef } from 'react';

/*
 * Renders a lazily loaded modal only once it has been opened, then keeps it
 * mounted — the same "ever opened" rule App already uses for the big module
 * modals. Before the first open nothing is rendered, so the modal's chunk is
 * not downloaded; after it, the component stays mounted exactly as it did
 * when it was imported eagerly (close animations, open-gated effects and
 * state resets all behave as before).
 */
export default function MountAfterFirstOpen({ open, fallback = null, children }) {
  const everOpenedRef = useRef(false);
  if (open) everOpenedRef.current = true;
  if (!everOpenedRef.current) return null;
  return <Suspense fallback={fallback}>{children}</Suspense>;
}
